import React from 'react';
import { Col, FormGroup, Label, Input, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PostCommon from 'Component/Common/Form/Post';
import { submitCategoryProduct } from 'Services/Features/CategoryProduct/Utils/categoryProductUtils';
import { setFormData, resetFormData } from 'Services/Features/CategoryProduct/categoryProductSlice';
import CustomLoader from 'Component/Common/CustomLoader';

const CategoryProductForm = ({ label, setRefetch }) => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const data = useSelector(state => state.categoryProduct.currentCategoryProduct)
    console.log (data, 'data');
    const startUpload = useSelector(state => state.categoryProduct.loading);

    const handleSuccess = () => {
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/product-category`);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(data, 'data');
        dispatch(submitCategoryProduct({ ...data, successCallback: handleSuccess }))
    };

    const handleDiscard = (e) => {
        e.preventDefault();
        dispatch(resetFormData());
        history(`${process.env.PUBLIC_URL}/product-category`);
    };
    const handleChanges = (e) => {
        const { name, value } = e.target;
        dispatch(setFormData({ [name]: value }));
    }


    return (
        <PostCommon title={label} handleSubmit={handleSubmit} handleDiscard={handleDiscard} colProps={{ md: 8, lg: 10, xl: 8 }}>
            {startUpload && (
                <CustomLoader />
            )}
            <div>
                <Row className="mb-3">
                    <Col sm="12" lg="12" xl="12">
                        <FormGroup className='mb-3'>
                            <Label for="validationName" style={{ fontWeight: 'bold' }}>Nama :</Label>
                            <Input
                                className="form-control"
                                id="validationName"
                                type="text"
                                name="name"
                                placeholder="Masukkan nama kategori produk..."
                                required=""
                                value={data.name}
                                onChange={handleChanges}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        </PostCommon>
    );
};

export default CategoryProductForm;